import mixitup from 'mixitup';

var buttonFilter = {
  filters: null,
  reset: null,
  container: null,
  sortHost: null,
  sortRegion: null,
  sort: null,
  groups: [],
  outputArray: [],
  outputString: '',
  buttonFilterString: 'all',
  setFormatFilterString: 'all',
  textFilterString: '',
  currentSort: 'default',
  mixer: null,
  prepared: false,
  snapshotsCaptured: false,
  initialized: false,
  originalContainers: [],
  positionSealedProductFrames: null,

  init: function() {
    var self = this;
    if (self.initialized) return;
    self.initialized = true;

    self.filters = document.getElementById('spoiler-card-filters');
    self.reset = document.querySelectorAll('.filter-group-reset-link');
    self.sortRegion = document.querySelector('.spoiler-card-sort-region');
    self.container = document.querySelector('.spoiler-grouped-view') || document.querySelector('.spoiler-card-container');
    self.sortHost = document.querySelector('.spoiler-sort-host');
    self.sort = document.querySelectorAll('.sort');
    self.groups = [];
    self.outputString = 'all';
    self.buttonFilterString = 'all';
    self.setFormatFilterString = 'all';
    self.textFilterString = '';
    self.currentSort = 'default';

    if (self.filters) {
      self.filters.querySelectorAll('fieldset').forEach(function(fieldset) {
        self.groups.push({
          buttons: fieldset.querySelectorAll('.filter'),
          active: ''
        });
      });
    }

    self.bindHandlers();
  },

  bindHandlers: function() {
    var self = this;

    if (self.filters) {
      self.filters.addEventListener('click', function(e) {
        var button = e.target.closest('.filter');
        if (!button) return;
        e.preventDefault();
        if (button.classList.contains('active')) {
          button.classList.remove('active');
        } else {
          button.classList.add('active');
          button.parentElement.querySelectorAll('.filter').forEach(function(sib) {
            if (sib !== button) sib.classList.remove('active');
          });
        }
        self.parseFilters();
      });
    }

    self.sort.forEach(function(sortEl) {
      sortEl.addEventListener('change', function(e) {
        e.preventDefault();
        self.changeSort(sortEl.value);
      });
    });

    self.reset.forEach(function(resetEl) {
      resetEl.addEventListener('click', function(e) {
        e.preventDefault();
        if (self.filters) {
          self.filters.querySelectorAll('.filter').forEach(function(btn) {
            btn.classList.remove('active');
          });
        }
        self.parseFilters();
      });
    });
  },

  parseFilters: function() {
    var self = this;
    self.groups.forEach(function(group) {
      var activeBtn = Array.from(group.buttons).find(function(b) { return b.classList.contains('active'); });
      group.active = activeBtn ? (activeBtn.dataset.filter || '') : '';
    });
    self.concatenate();
  },

  concatenate: function() {
    var self = this;
    self.buttonFilterString = '';
    self.groups.forEach(function(group) {
      self.buttonFilterString += group.active;
    });
    if (!self.buttonFilterString.length) self.buttonFilterString = 'all';
    self.applyCurrentFilter();
  },

  setTextFilter: function(searchValue) {
    this.textFilterString = searchValue || '';
    this.applyCurrentFilter();
  },

  setSetFormatFilter: function(selector) {
    this.setFormatFilterString = selector || 'all';
    this.applyCurrentFilter();
  },

  currentSelector: function() {
    var textSelector = this.textFilterString ? '[data-name*="' + this.escapeAttributeValue(this.textFilterString) + '"]' : '';
    var buttonSelector = this.buttonFilterString === 'all' ? '' : this.buttonFilterString;
    var suffixSelector = buttonSelector + textSelector;
    var setFormatSelectors = this.setFormatFilterString === 'all' ? [''] : this.setFormatFilterString.split(',').map(function(selector) {
      return selector.trim();
    }).filter(Boolean);
    this.outputString = setFormatSelectors.map(function(selector) {
      return selector + suffixSelector;
    }).join(',');
    return this.outputString || 'all';
  },

  escapeAttributeValue: function(value) {
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  },

  prepareSpoilerSort: function(options) {
    options = options || {};
    if (this.prepared || !this.container || !this.sortHost) return;

    this.positionSealedProductFrames = options.positionSealedProductFrames || this.positionSealedProductFrames;
    this.wrapSpoilerCards();
    this.prepared = true;
  },

  captureOriginalSnapshots: function() {
    if (this.snapshotsCaptured || !this.container) return;

    this.originalContainers = [this.container].concat(Array.from(this.container.querySelectorAll('.spoiler-card-container')));
    this.originalContainers.forEach(function(container) {
      container._spoilerOriginalChildren = Array.from(container.childNodes);
    });
    this.snapshotsCaptured = true;
  },

  wrapSpoilerCards: function() {
    var self = this;
    Array.from(self.container.querySelectorAll('.spoiler-card.mix')).forEach(function(card) {
      if (card.closest('.spoiler-card-unit')) return;

      var unit = document.createElement('div');
      unit.className = self.unitClassName(card);
      Object.keys(card.dataset).forEach(function(key) {
        unit.dataset[key] = card.dataset[key];
        delete card.dataset[key];
      });

      card.classList.remove('mix');
      card.parentNode.insertBefore(unit, card);
      unit.appendChild(card);

      var next = unit.nextElementSibling;
      if (next && next.matches('ins.float-start')) {
        unit.appendChild(next);
      }
    });
  },

  unitClassName: function(card) {
    var classes = Array.from(card.classList).filter(function(className) {
      return className !== 'spoiler-card';
    });
    if (classes.indexOf('mix') === -1) classes.push('mix');
    classes.unshift('spoiler-card-unit');
    return Array.from(new Set(classes)).join(' ');
  },

  ensureMixer: function() {
    if (this.mixer || !this.sortHost) return;
    this.mixer = mixitup(this.sortHost, {
      animation: { enable: false },
      controls: { enable: false }
    });
  },

  changeSort: function(sortValue) {
    this.currentSort = sortValue || 'default';
    if (this.currentSort === 'default') {
      this.restoreGroupedView();
    } else {
      this.showSortedView();
    }
  },

  showSortedView: function() {
    if (!this.prepared) this.prepareSpoilerSort();
    if (!this.container || !this.sortHost) return;

    var fragment = document.createDocumentFragment();
    Array.from(this.container.querySelectorAll('.spoiler-card-unit.mix')).forEach(function(unit) {
      fragment.appendChild(unit);
    });
    this.sortHost.hidden = false;
    this.sortHost.appendChild(fragment);
    this.container.hidden = true;
    if (this.sortRegion) this.sortRegion.classList.add('spoiler-sorted');
    this.ensureMixer();
    if (this.mixer) this.mixer.forceRefresh();
    this.applyCurrentFilter();
    if (this.mixer) this.mixer.sort(this.currentSort);
  },

  restoreGroupedView: function() {
    var self = this;
    if (!self.container || !self.sortHost) return;

    if (self.snapshotsCaptured) {
      self.originalContainers.forEach(function(container) {
        if (container._spoilerOriginalChildren) {
          container.replaceChildren.apply(container, container._spoilerOriginalChildren);
        }
      });
    }

    self.container.hidden = false;
    self.sortHost.hidden = true;
    if (self.sortRegion) self.sortRegion.classList.remove('spoiler-sorted');
    self.applyGroupedFilter(self.currentSelector());
    if (typeof self.positionSealedProductFrames === 'function') {
      self.positionSealedProductFrames();
    }
  },

  applyCurrentFilter: function() {
    var selector = this.currentSelector();
    if (this.currentSort !== 'default' && this.mixer) {
      this.mixer.filter(selector);
      this.updateFilterEmptyState(selector);
    } else {
      this.applyGroupedFilter(selector);
    }
  },

  applyGroupedFilter: function(selector) {
    if (!this.container) return;

    var visibleCount = 0;
    this.container.querySelectorAll('.spoiler-card-unit.mix').forEach(function(unit) {
      var visible = selector === 'all' || unit.matches(selector);
      unit.style.display = visible ? '' : 'none';
      if (visible) visibleCount += 1;
    });

    this.syncGroupedSectionVisibility();
    this.updateFilterEmptyState(selector, visibleCount);
  },

  syncGroupedSectionVisibility: function() {
    if (!this.container) return;

    this.container.querySelectorAll('.spoiler-card-section').forEach(function(section) {
      var hasVisibleCard = Array.from(section.querySelectorAll('.spoiler-card-unit.mix')).some(function(unit) {
        return unit.style.display !== 'none';
      });
      section.hidden = !hasVisibleCard;
    });
  },

  updateFilterEmptyState: function(selector, visibleCount) {
    var emptyState = document.querySelector('.spoiler-card-filter-empty');
    if (!emptyState) return;

    if (visibleCount === undefined) {
      var host = this.currentSort !== 'default' && this.sortHost && !this.sortHost.hidden ? this.sortHost : this.container;
      visibleCount = 0;
      if (host) {
        host.querySelectorAll('.spoiler-card-unit.mix').forEach(function(unit) {
          if (selector === 'all' || unit.matches(selector)) visibleCount += 1;
        });
      }
    }

    emptyState.hidden = visibleCount > 0;
  }
};

export { buttonFilter };

window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.buttonFilter = buttonFilter;
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() {
  buttonFilter.init();

  function filterByString(searchValue) {
    buttonFilter.setTextFilter(searchValue);
  }

  var textFilter = document.querySelector(".spoiler-text-filter");
  if (textFilter) {
    var keyupTimeout;
    var scheduleTextFilter = function() {
      var searchValue;
      if (textFilter.value.length < 3) {
        searchValue = '';
      } else {
        searchValue = textFilter.value.toLowerCase().trim();
      }
      clearTimeout(keyupTimeout);
      keyupTimeout = setTimeout(function() {
        filterByString(searchValue);
      }, 350);
    };

    textFilter.addEventListener('input', scheduleTextFilter);
    textFilter.addEventListener('keyup', scheduleTextFilter);
  }

  document.querySelectorAll(".spoiler-card-unofficial-blocker").forEach(function(el) {
    el.addEventListener('click', function() {
      document.querySelectorAll(".spoiler-card-unofficial-blocker").forEach(function(b) {
        b.style.display = 'none';
      });
    });
  });
});
